import { events } from '../../Constants';
import { initCanvas, refreshDesignAndText } from './canvas';
import {
  DesignLabels, Designs,
} from './constants';
import { handleAddToCart, initDesignOptions, updateCustomisationOptions } from './core';
import { logAddPersonalisedMessage, logAddPersonalisedDate } from '../../analytics';

const refresh = () => {
  const colorInputCtr = document.querySelector('.js-engraving-color-options');
  const potInputCtr = document.querySelector('.js-select-planter') as HTMLElement;
  const colorInput = colorInputCtr.querySelector('input[name="engraving-color"]:checked');
  const customTextInput = document.querySelector('.js-engraving-custom-text');
  const customTextInput2 = document.querySelector('.js-engraving-custom-text-2');
  const designInputCtr = document.querySelector('input[name="design-option"]:checked');
  const dateInputCtr = document.querySelector('.js-engraving-date-picker') as HTMLInputElement;

  const potColor = ((colorInput || document.querySelector('input[name="engraving-color"]')) as HTMLInputElement).value;
  const selectedPot = potInputCtr.querySelector('input[name="planter"]:checked,input[name="Pot"]:checked') as HTMLInputElement;
  const engravingDesign = (designInputCtr as HTMLInputElement).value;
  const customText = (customTextInput as HTMLInputElement).value;
  const customText2 = (customTextInput2 as HTMLInputElement).value;

  if (selectedPot?.dataset.handle === 'custom-plant-pots' || selectedPot?.value === 'Custom Pot') {
    refreshDesignAndText({
      potColor,
      engravingDesign,
      customText,
      customText2,
      customDate: dateInputCtr.value,
    });
  }
};

const handleDesignChange = (e: InputEvent) => {
  const selectedDesign = (e.target as HTMLInputElement).value;
  const selectedDesignInfoEl = document.querySelector('.js-selected-engraving-design') as HTMLElement;
  const customTextInput: HTMLInputElement = document.querySelector('.js-engraving-custom-text');

  if (!customTextInput.hasAttribute('is-dirty')) {
    if (selectedDesign !== Designs.CUSTOM_TEXT) {
      customTextInput.value = '';
    } else {
      customTextInput.value = 'Sample Text 1';
    }
  }

  selectedDesignInfoEl.innerText = DesignLabels[selectedDesign];
  updateCustomisationOptions(selectedDesign);
  refresh();
};

const handleTextInput = (e: InputEvent) => {
  const { target } = e;
  e.preventDefault();
  e.stopPropagation();

  (target as HTMLInputElement).value = (target as HTMLInputElement).value;

  refresh();
};

const handleTextChange = (e: InputEvent) => {
  const { target } = e;

  if ((target as HTMLInputElement).value) {
    logAddPersonalisedMessage(true);
  }
};

const handleTextInputFocus = (e: InputEvent) => {
  const customTextInput = e.target as HTMLInputElement;

  if (!customTextInput.hasAttribute('is-dirty')) {
    customTextInput.value = '';
    customTextInput.setAttribute('is-dirty', 'true');
    refresh();
  }
};

const handlePotColorChange = () => {
  const selectedPotInfoEl = document.querySelector('.js-selected-engraving-pot-color') as HTMLElement;
  const colorInputCtr = document.querySelector('.js-engraving-color-options');
  const colorInput = colorInputCtr.querySelector('input[name="engraving-color"]:checked');
  selectedPotInfoEl.innerText = colorInput.getAttribute('data-title');

  refresh();
};

const toggleEngravingDrawer = (toOpen: boolean) => {
  const $window = $(window);

  if (toOpen) {
    document.body.classList.add('engraving-vis-drawer--open');
    document.body.classList.remove('engraving-vis-drawer--closed');
    $window.trigger(events.overlay.show);
  } else {
    document.body.classList.add('engraving-vis-drawer--closed');
    document.body.classList.remove('engraving-vis-drawer--open');
    $window.trigger(events.overlay.hide);
  }
};

const addListeners = () => {
  const engravingDrawerTrigger = document.querySelector('[data-engraving-drawer-trigger]');
  const colorInputCtr = document.querySelector('.js-select-color-options');
  const potInputCtr = document.querySelector('.js-select-planter');
  const customPotInputs = document.querySelectorAll('input[data-handle="custom-plant-pots"]+label,input[value="Custom Pot"]+label');
  const customTextInput = document.querySelector('.js-engraving-custom-text');
  const customTextInput2 = document.querySelector('.js-engraving-custom-text-2');
  const designInputCtr = document.querySelector('.js-engraving-design-options');
  const addToCartBtn = document.querySelector('.js-engraving-visualizer button[type="submit"]');
  const dateInputCtr = document.querySelector('.js-engraving-date-picker') as HTMLInputElement;
  const closeDrawerEl = document.querySelector('.engraving-vis-drawer__close');
  const potColorsEl = document.querySelector('.js-engraving-color-options');

  if (engravingDrawerTrigger) {
    engravingDrawerTrigger.addEventListener('click', () => {
      toggleEngravingDrawer(true);
    });
  }

  if (closeDrawerEl) {
    closeDrawerEl.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleEngravingDrawer(false);
    });
  }

  designInputCtr.addEventListener('change', handleDesignChange);
  customTextInput.addEventListener('input', handleTextInput);
  customTextInput.addEventListener('change', handleTextChange);
  customTextInput.addEventListener('focus', handleTextInputFocus);
  customTextInput2.addEventListener('focus', handleTextInputFocus);
  customTextInput2.addEventListener('input', handleTextInput);
  customTextInput2.addEventListener('change', handleTextChange);
  colorInputCtr.addEventListener('change', refresh);
  potInputCtr.addEventListener('change', refresh);
  potColorsEl.addEventListener('change', handlePotColorChange);

  customPotInputs.forEach((c) => {
    c.addEventListener('click', () => {
      refresh();
      toggleEngravingDrawer(true);
    });
  });

  addToCartBtn.addEventListener('click', handleAddToCart);
  dateInputCtr.addEventListener('onDateSelect', () => {
    logAddPersonalisedDate(true);
    refresh();
  });
};

const handlePreOpen = () => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('custom_engraving') === '1') {
    toggleEngravingDrawer(true);
  }
};

const init = async () => {
  const customPotInputs = document.querySelectorAll('input[data-handle="custom-plant-pots"]+label,input[value="Custom Pot"]+label');

  if (!customPotInputs.length) {
    return;
  }

  initDesignOptions();
  await initCanvas();
  addListeners();
  refresh();
  handlePreOpen();
};

init();
